import React, { useState } from "react";

function Header(){
    return(
        <>
            <div className="head">
                <img src="https://www.logo.wine/a/logo/GitHub/GitHub-Logo.wine.svg" width="150px" />
                <h1>GitHub Profile Viewer</h1>
            </div>
            
        </>
    )
}
export default Header;